(function () {
  function normaliseText(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .trim()
      .toLowerCase();
  }

  function rangeTargetForAnchor(anchor) {
    if (!anchor) return null;

    var text = normaliseText(anchor.textContent);
    var href = anchor.getAttribute('href') || '';

    // Text-based fixing catches links stored in Shopify Admin navigation menus.
    if (text === 'under £15' || text === 'under 15' || text === 'under £15 products') {
      return '/collections/under-15';
    }

    if (text === 'under £30' || text === 'under 30' || text === 'under £30 products') {
      return '/collections/under-30';
    }

    if (text === '£30+' || text === '30+' || text === 'over £30' || text === '£30+ products') {
      return '/collections/above-30';
    }

    // URL-based fixing catches old currency-sensitive price-filter links.
    if (/filter\.(v|p)\.price\.lte=(15|1500)(?:&|$)/.test(href)) {
      return '/collections/under-15';
    }

    if (/filter\.(v|p)\.price\.lte=(30|3000)(?:&|$)/.test(href)) {
      return '/collections/under-30';
    }

    if (/filter\.(v|p)\.price\.gte=(30|3000)(?:&|$)/.test(href)) {
      return '/collections/above-30';
    }

    return null;
  }

  function fixCuratedRangeLinks(scope) {
    var root = scope || document;
    root.querySelectorAll('a').forEach(function (anchor) {
      var target = rangeTargetForAnchor(anchor);
      if (!target) return;
      anchor.setAttribute('href', target);
      anchor.dataset.kenzeCuratedRangeFixed = 'true';
    });
  }

  function redirectOldRangeUrls() {
    var params = new URLSearchParams(window.location.search || '');
    var path = window.location.pathname || '';
    var isCollectionAll = path === '/collections/all' || path === '/collections';

    if (!isCollectionAll) return;

    var lte = params.get('filter.v.price.lte') || params.get('filter.p.price.lte');
    var gte = params.get('filter.v.price.gte') || params.get('filter.p.price.gte');
    var target = null;

    if (lte === '15' || lte === '1500') {
      target = '/collections/under-15';
    } else if (lte === '30' || lte === '3000') {
      target = '/collections/under-30';
    } else if (gte === '30' || gte === '3000') {
      target = '/collections/above-30';
    }

    if (target && window.location.pathname !== target) {
      window.location.replace(target);
    }
  }

  redirectOldRangeUrls();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fixCuratedRangeLinks(document);
    });
  } else {
    fixCuratedRangeLinks(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixCuratedRangeLinks(event.target || document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('a')) {
          fixCuratedRangeLinks(node.parentNode || document);
        } else {
          fixCuratedRangeLinks(node);
        }
      });
    });
  });

  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a') : null;
    var target = rangeTargetForAnchor(anchor);
    if (!target) return;
    if (anchor.getAttribute('href') !== target) {
      anchor.setAttribute('href', target);
    }
  }, true);

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
